import {
  IMarketArticlesFilterBoundary,
  IMarketArticlesFilterPayload,
} from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IMarketArticle';
import { initialArticlesFilterState } from '@/creditflowresearch/application/ArticlesAndStats/Articles/constants';
import {
  FILTER_APPLY,
  FILTER_MAX_DATE_TO,
  FILTER_MIN_DATE_FROM,
  FILTER_PAYLOAD,
  GET_FILTERS,
  GET_FILTERS_ERROR,
  GET_FILTERS_SUCCESS,
  INITIAL_FILTERS,
  RESET_FILTER_MIN_MAX_DATE,
  RESET_FILTERS,
} from './actionTypes';

export interface IArticlesFilterState {
  isFetching: boolean,
  items: {
    hash: string,
    filter: IMarketArticlesFilterBoundary,
  },
  initialFilters: IMarketArticlesFilterPayload,
  appliedFilters: IMarketArticlesFilterPayload,
  filtersPayload: IMarketArticlesFilterPayload,
  dateFromMin: number | null,
  dateToMax: number | null,
}

export const initialState: IArticlesFilterState = {
  isFetching: false,
  items: {
    filter: {
      dealList: { allowed: [], selected: [] },
      parentIssuerList: { allowed: [], selected: [] },
      dateFrom: null,
      dateTo: null,
      regionList: [],
      sectorList: [],
      industryList: [],
      productList: [],
    },
    hash: '',
  },
  initialFilters: initialArticlesFilterState,
  appliedFilters: initialArticlesFilterState,
  filtersPayload: initialArticlesFilterState,
  dateFromMin: null,
  dateToMax: null,
};

export default (state:IArticlesFilterState = initialState, action):IArticlesFilterState => {
  switch (action.type) {
    case GET_FILTERS:
      return {
        ...state,
        isFetching: true,
      };
    case GET_FILTERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        items: {
          filter: {
            ...state.items.filter,
            ...action.payload.filter,
          },
          hash: action.payload.hash,
        },
      };
    case GET_FILTERS_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case FILTER_PAYLOAD:
      return {
        ...state,
        filtersPayload: action.payload,
      };
    case FILTER_APPLY:
      return {
        ...state,
        appliedFilters: action.payload,
      };
    case INITIAL_FILTERS:
      return {
        ...state,
        initialFilters: action.payload,
      };
    case FILTER_MIN_DATE_FROM:
      return {
        ...state,
        dateFromMin: action.payload,
      };
    case FILTER_MAX_DATE_TO:
      return {
        ...state,
        dateToMax: action.payload,
      };
    case RESET_FILTER_MIN_MAX_DATE:
      return {
        ...state,
        dateFromMin: null,
        dateToMax: null,
      };
    case RESET_FILTERS:
      return initialState;
    default:
      return state;
  }
};
